class TabComponent extends HTMLElement {
  constructor() {
    super();

    this._tab_toggles = this.querySelectorAll('.tab-toggles__toggle');
    this._tab_contents = this.querySelectorAll('.tab-contents__content');

    this._init();
  }

  _init() {
    this._tab_toggles.forEach((tabToggle) => {
      tabToggle.addEventListener('click', this._handle_open.bind(this));
    });
  }

  _handle_open(e) {
    this._reset_tabs();
    const target = document.getElementById(e.currentTarget.dataset.id);

    target.classList.add('block');
    target.classList.add('animate-fade-up');
    target.classList.remove('hidden');

    e.target.classList.remove('btn-fifth');
    e.target.classList.add('btn-fourth');
  }

  _reset_tabs() {
    this._tab_toggles.forEach((tabToggle) => {
      tabToggle.classList.remove('btn-fourth');
      tabToggle.classList.add('btn-fifth');
    });
    this._tab_contents.forEach((tabContent) => {
      tabContent.classList.remove('block');
      tabContent.classList.add('hidden');
    });
  }
}

customElements.define('tab-component', TabComponent);
